/* Normalize misconfigured relative review links from injected HTML/apps. */
(() => {
  const repair = (root) => {
    root.querySelectorAll?.('a[href]').forEach((a) => {
      const raw = (a.getAttribute('href') || '').trim();
      if (/^(?:\.\/)?pages\/reviews(?:[?#].*)?$/i.test(raw)) {
        a.setAttribute('href', '/' + raw.replace(/^\.\//, ''));
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => repair(document), {once:true});
  } else repair(document);
})();
